"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _round2 = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Show the list of values in an array
 * 
 * "renderAs": {
        "type": "ListRender",
        "class": "html",
        "settings": {
            "values": [
                {
                    "valuePath": "sdqPre.devTags.SDQStudentTotalDifficultiesScore",
                    "prefix": "",
                    "suffix": "",
                    "round": true, // use Math.round to round value
                    "ifValue": { // if value is 0, display M; otherwise display value
                        "value": 0, 
                        "display": "M"
                    }
                },
                {
                    "valuePath": "sdqPost.devTags.SDQStudentTotalDifficultiesScore",
                    "prefix": "",
                    "suffix": "",
                    "round": true,
                    "ifValue": {
                        "value": 0,
                        "display": "M"
                    }
                }
            ],
            "scale": [  // min/max value to highlight in color
                {
                    "min": 20,
                    "max": 40,
                    "colorClass": "veryHigh"
                },
                {
                    "min": 18,
                    "max": 19,
                    "colorClass": "high"
                },
                {
                    "min": 15,
                    "max": 17,
                    "colorClass": "mid"
                },
                {
                    "min": 0,
                    "max": 13,
                    "colorClass": "average"
                }
            ]
        }
    }

    Output in the cell:
 *     Pre: 10/20/2018
 *     Post: 02/20/2019
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: _style["default"].container,
      style: settings.rightAlign ? {
        padding: settings.truncateSpace ? '0 0.5em 0.5em 0.5em' : '0.5em'
      } : {
        textAlign: 'center',
        padding: settings.truncateSpace ? '0 0.5em 0.5em 0.5em' : '0.5em'
      }
    }, settings.values.map(function (item, index) {
      var colorValue = '';
      if (settings.scale !== 'undefined' && !(0, _isNil2["default"])(settings.scale)) {
        for (var i = 0; i < settings.scale.length; i++) {
          if (row[item.valuePath] >= settings.scale[i].min && row[item.valuePath] <= settings.scale[i].max) {
            colorValue = settings.scale[i].colorClass;
            break;
          }
        }
      }
      var itemValue = row[item.valuePath] !== null ? row[item.valuePath] : null;

      // manipulate value if needed
      if (item.round) {
        if (item.decimalPlaces) {
          itemValue = (0, _round2["default"])(itemValue, item.decimalPlaces);
        } else {
          itemValue = Math.round(itemValue);
        }
      }
      if (item.ifValue && itemValue === item.ifValue.value) {
        itemValue = item.ifValue.display;
      }
      if (settings.truncateSpace) {
        return row[item.valuePath] !== null && /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: _style["default"][colorValue]
        }, item.prefix, itemValue, item.suffix);
      }
      return row[item.valuePath] !== null && /*#__PURE__*/_react["default"].createElement("p", {
        key: index,
        className: _style["default"][colorValue]
      }, item.prefix, itemValue, item.suffix);
    }));
  };
};